/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CspEnvironmentEnumDTO } from './csp-environment-enum-dto';
import { CspAccountStatusEnumDTO } from './csp-account-status-enum-dto';


/**
 * Details of linked Cryptographic Service Provider account in TSS Webservice. This information is read only and provided by the TSS Web Service - *Not yet in use on Sandbox*
 */
export interface CspAccountDTO { 
    /**
     * CSP key reference
     */
    cspKeyReference?: string;
    /**
     * Start of certificate validity
     */
    certificateStartDate?: string;
    /**
     * End of certificate validity
     */
    certificateEndDate?: string;
    environment?: CspEnvironmentEnumDTO;
    status?: CspAccountStatusEnumDTO;
}

export class ClsCspAccountDTO { 
    /**
     * CSP key reference
     */
    cspKeyReference?: string = undefined;
    /**
     * Start of certificate validity
     */
    certificateStartDate?: string = undefined;
    /**
     * End of certificate validity
     */
    certificateEndDate?: string = undefined;
    environment?: CspEnvironmentEnumDTO = undefined;
    status?: CspAccountStatusEnumDTO = undefined;
}



